// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tMwv","title":"styles_title__1wAqp"};